__webpack_require__.p = "https://qik-ai-org.github.io/Sign-MicroappV2/";